// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"71a17d3e","787":"816ff194"}[chunkId] + ".chunk.js";
};